@if ( !router?.url.endsWith('forbidden') && !router?.url.endsWith('404') && !router?.url.endsWith('internal-error') ) {
<syn-navigation-bar />
}
<div class="full">
  <router-outlet />
</div>
<syn-footer />
